import { Core } from "@faire/design-tokens";
import { optimizeProductImageUrl } from "@faire/web/common/images/optimizeImages";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { OrderNumber } from "./OrderNumber";
export var OrderItemCard = function OrderItemCard(_ref) {
  var _brand_order$order_it, _brand_order$order_it2;
  var brand_name = _ref.brand_name,
    retailer_name = _ref.retailer_name,
    order_placed_string = _ref.order_placed_string,
    summary_string = _ref.summary_string,
    brand_order = _ref.brand_order,
    isRetailer = _ref.isRetailer,
    onClick = _ref.onClick,
    order_number = _ref.order_number,
    status_string = _ref.status_string,
    innerRef = _ref.innerRef;
  var productImage = brand_order === null || brand_order === void 0 ? void 0 : (_brand_order$order_it = brand_order.order_items) === null || _brand_order$order_it === void 0 ? void 0 : (_brand_order$order_it2 = _brand_order$order_it[0]) === null || _brand_order$order_it2 === void 0 ? void 0 : _brand_order$order_it2.product_image;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  return /*#__PURE__*/React.createElement(OrderItemCardWrapper, {
    onClick: onClick,
    "data-test-id": "order-item-number-".concat(order_number),
    ref: innerRef
  }, productImage ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ItemImage, {
    src: optimizeProductImageUrl(productImage, false, isMobile ? 80 : 100),
    alt: "Order Item image"
  }), isMobile ? /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }) : /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }))) : null, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "subheadingSansMedium"
  }, isRetailer ? brand_name : retailer_name), /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(OrderNumber, null), /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "FM8ElT",
    defaultMessage: "Total"
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "1/2x"
  }), /*#__PURE__*/React.createElement(Typography, null, summary_string)), /*#__PURE__*/React.createElement(Spacer, {
    height: "1/2x"
  }), status_string ? ( /*#__PURE__*/React.createElement(Typography, null, status_string)) : ( /*#__PURE__*/React.createElement(Typography, null, order_placed_string))));
};
export var OrderItemCardWrapper = styled(Row).attrs({
  justify: "flex-start",
  align: "center"
}).withConfig({
  displayName: "OrderItemCard__OrderItemCardWrapper"
})(["border:1px solid ", ";border-radius:4px;padding:", ";&:hover{border:1px solid ", ";}min-height:120px;min-width:326px;height:auto;width:100%;cursor:pointer;"], Core.border.muted, getSpacing("2x"), Core.border["default"]);
var ItemImage = styled.img.withConfig({
  displayName: "OrderItemCard__ItemImage"
})(["height:100px;width:100px;", "{height:80px;width:80px;}"], responsiveMediaQueries.mobile);